/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var map = {
  WebkitTransition: 'webkitTransitionEnd',
  MozTransition: 'transitionend',
  OTransition: 'oTransitionEnd',
  msTransition: 'MSTransitionEnd',
  transition: 'transitionend'
};
var EL;
var RESULT;
var _default = function _default() {
  if (!EL) {
    EL = document.createElement('p');
  }
  if (RESULT) {
    return RESULT;
  }
  for (var transition in map) {
    if (EL.style[transition] != null) {
      RESULT = map[transition];
      break;
    }
  }
  return RESULT;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/getTransitionEnd.js
// module id = 639
// module chunks = 0